import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGetAuftragMessagesListeMutation } from '../../../api/AuftragMessagesAPI';


interface ThisProps {
  //callback1?: (location: ILocation) => void; // Callback-Prop
  //statusChanged: () => void;
  //changeColor: (auftraguid: string, color: string) => void;
  //centerOnMap: (id: string) => void;
  //auftragUid: string,
}

/**
 * @author noone
 */
const ChatButtonComponent: React.FC<ThisProps> = ({  }) => {

  const navigate = useNavigate();

  const [anzahlNeueNachrichten, setAnzahlNeueNachrichten] = useState<number>(0);

  const [getChatListe] = useGetAuftragMessagesListeMutation();

  useEffect(() => {
    let anzahl: number = 0
    getChatListe().unwrap()
      .then((data) => {
        data.map((e) => {
          anzahl += e.anzahl_nicht_gelesen;
        });
      })
      .catch((error) => console.error("Fehler beim Laden der Chat Liste:", error))
      .finally(() => {
        setAnzahlNeueNachrichten(anzahl);
      });

  }, [getChatListe]);

  useEffect(() => {

  }, []);

  return (
    <>
      <button
        onClick={() => navigate("/chat")}
        className="btn btn-outline-primary position-relative"
      >
        <i className="bi bi-chat"></i>

        {anzahlNeueNachrichten > 0 &&
          <span style={{ color: "white" }}
            className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-success"
          >
            {anzahlNeueNachrichten}
          </span>
        }
      </button>
    </>
  );

}

export default ChatButtonComponent;